import { createContext, useContext } from "react";

/**
 * Whether bill grid links (bill title, lien-waiver tag) navigate to the standalone full-page Bill
 * route (`true`) or mount the Bill modal over the current list route (`false`).
 *
 * Kept in context so the Bills list can flip its view mode in place — toggling the provider value
 * re-renders the link cells (context updates cross `memo` boundaries) without a grid data refetch.
 * Defaults to `false` (modal) for any grid rendered without a provider (e.g. the Bill Approval
 * Queue), preserving prior behavior.
 */
export const BillLinkAbsoluteContext = createContext<boolean>(false);

export const useBillLinkAbsolute = (): boolean => useContext(BillLinkAbsoluteContext);
